import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { OTHERS_LABEL } from "@/lib/deviceCatalog";

/**
 * TesterDeviceInput — an Input paired with a <datalist> populated from the
 * signed-in tester's device_inventory. Testers can pick a device from the
 * dropdown OR type their own. Falls back to a plain input for admins/managers
 * or testers with no devices yet.
 */
export default function TesterDeviceInput({ value, onChange, placeholder = "iPhone 15 Pro", testid = "input-device" }) {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (data?.role === "freelancer" && Array.isArray(data.device_inventory)) {
          setDevices(data.device_inventory);
        }
      } catch { /* signed-out or non-tester — datalist stays empty */ }
    })();
  }, []);

  const options = devices
    .map(d => {
      const plat = d.platform === OTHERS_LABEL ? (d.platform_custom || d.platform) : d.platform;
      const ver = d.release_version === OTHERS_LABEL ? (d.release_version_custom || d.release_version) : d.release_version;
      return `${d.model || "Unknown"} — ${plat || ""} ${ver || ""}`.trim();
    })
    .filter(Boolean);

  const listId = options.length > 0 ? `${testid}-list` : undefined;

  return (
    <>
      <Input
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        data-testid={testid}
      />
      {listId && (
        <datalist id={listId} data-testid={`${testid}-datalist`}>
          {options.map((opt, i) => <option key={i} value={opt} />)}
        </datalist>
      )}
    </>
  );
}
